import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';  // Import i18n translation hook
import "../homepage/home.css";

const WelcomeVideoModal = ({ isInline, preferMp4 = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);  // Control modal visibility
  const [availableTracks, setAvailableTracks] = useState({ en: false, fr: false });
  const videoRef = useRef(null);
  const { i18n } = useTranslation();  // Access i18n instance

  const locale = i18n.language?.toLowerCase() || "en";
  const isFrenchLocale = locale.startsWith("fr");
  const videoSrc = encodeURI(
    isFrenchLocale
      ? "/site-images-videos/design_Realiste_fr.mp4"
      : "/site-images-videos/Creating Realistic Home Facade Designs Using AI.mp4"
  );
  const englishCaptionsSrc = encodeURI("/site-images-videos/Creating Realistic Home Facade Designs Using AI.en.vtt");
  const frenchCaptionsSrc = encodeURI(
    isFrenchLocale
      ? "/site-images-videos/design_Realiste_fr.vtt"
      : "/site-images-videos/Creating Realistic Home Facade Designs Using AI.fr.vtt"
  );

  useEffect(() => {
    let isMounted = true;

    Promise.all([
      fetch(englishCaptionsSrc, { method: "HEAD" }).then((response) => response.ok).catch(() => false),
      fetch(frenchCaptionsSrc, { method: "HEAD" }).then((response) => response.ok).catch(() => false),
    ]).then(([hasEnglish, hasFrench]) => {
      if (isMounted) {
        setAvailableTracks({ en: hasEnglish, fr: hasFrench });
      }
    });

    return () => {
      isMounted = false;
    };
  }, [englishCaptionsSrc, frenchCaptionsSrc]);

  const handleSkipVideo = () => {
    setIsModalOpen(false);
    localStorage.setItem('hasSeenVideo', 'true');  // Set localStorage flag
  };

  if (!isModalOpen) return null;

  return (
    <div className={isInline ? "" : "welcome-video-overlay"}>
      <div className={isInline ? "" : "welcome-video-content"}>
        <video
          ref={videoRef}
          muted
          controls
          style={{ width: '100%', height: 'auto' }}
        >
          <source src={videoSrc} type="video/mp4" />
          {availableTracks.fr && (
            <track
              kind="captions"
              src={frenchCaptionsSrc}
              srcLang="fr"
              label="Francais"
              default={isFrenchLocale}
            />
          )}
          {availableTracks.en && (
            <track
              kind="captions"
              src={englishCaptionsSrc}
              srcLang="en"
              label={isFrenchLocale ? "Anglais" : "English"}
            />
          )}
          Your browser does not support the video tag.
        </video>

        {!isInline && (
          <button 
            className="skip-button" 
            onClick={handleSkipVideo} 
            style={{
              marginTop: '10px',
              padding: '10px 20px',
              backgroundColor: '#4caf50',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Skip
          </button>
        )}
      </div>
    </div>
  );
};

export default WelcomeVideoModal;
